import dynamic from 'next/dynamic';
import useModal from 'src/components/Modals/hooks/useModal';

const DevModal = dynamic(() => import('src/components/DevModal'));
const DevFeatureFlagModal = dynamic(
	() => import('src/components/Modals/DevFeatureFlagModal')
);
const EmulateWalletModal = dynamic(
	() => import('src/components/Modals/EmulateWalletModal')
);
const PrivyDevModal = dynamic(
	() => import('src/components/Modals/PrivyDevModal')
);

export default function DevModals() {
	const { currentModal } = useModal();

	return (
		<>
			{currentModal?.type === 'dev_tools' && <DevModal />}
			{currentModal?.type === 'feature_flag' && <DevFeatureFlagModal />}
			{currentModal?.type === 'emulation' && <EmulateWalletModal />}
			{currentModal?.type === 'privy_dev' && <PrivyDevModal />}
		</>
	);
}
